var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgALogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "226.77px",
    height: "226.77px",
    viewBox: "0 0 226.77 226.77",
    style: {
      enableBackground: "new 0 0 226.77 226.77"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -0.002,
    style: {
      fill: "#CF0039"
    },
    width: 226.771,
    height: 226.772
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M143.062,171.092l-9.062-25.701H91.825l-9.062,25.701H58.049l44.155-115.325h22.406l43.823,115.325 H143.062z M118.68,102.555c-2.307-6.754-4.614-13.673-5.768-17.957c-1.152,4.284-3.458,11.203-5.766,17.957l-7.415,20.924h26.363 L118.68,102.555z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F18A00"
    },
    d: "M53.274,116.617c-0.543,1.617-2.294,2.488-3.911,1.945l-32.162-10.793 c-1.616-0.543-2.489-2.293-1.946-3.91l2.675-7.969c0.543-1.616,2.294-2.487,3.911-1.945l32.161,10.795 c1.617,0.542,2.49,2.293,1.947,3.91L53.274,116.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F18A00"
    },
    d: "M51.519,141.869c0.542,1.617-0.33,3.368-1.949,3.91l-22.909,8.131 c-1.618,0.542-3.367-0.331-3.909-1.948l-2.669-7.97c-0.541-1.617,0.331-3.368,1.949-3.909l22.91-8.132 c1.617-0.542,3.367,0.331,3.909,1.948L51.519,141.869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F18A00"
    },
    d: "M45.213,68.327c-1.35,1.042-1.598,2.982-0.554,4.333l14.518,19.499 c1.045,1.349,2.982,1.597,4.333,0.555l6.649-5.14c1.35-1.044,1.599-2.983,0.555-4.334L56.196,63.741 c-1.043-1.35-2.982-1.598-4.333-0.555L45.213,68.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F18A00"
    },
    d: "M172.977,116.617c0.543,1.617,2.294,2.488,3.911,1.945l32.163-10.793 c1.615-0.543,2.488-2.293,1.945-3.91l-2.675-7.969c-0.543-1.616-2.294-2.487-3.911-1.945l-32.161,10.795 c-1.617,0.542-2.49,2.293-1.947,3.91L172.977,116.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F18A00"
    },
    d: "M174.732,141.869c-0.543,1.617,0.33,3.368,1.949,3.91l22.908,8.131 c1.619,0.542,3.369-0.331,3.909-1.948l2.669-7.97c0.542-1.617-0.33-3.368-1.949-3.909l-22.909-8.132 c-1.617-0.542-3.368,0.331-3.909,1.948L174.732,141.869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F18A00"
    },
    d: "M181.038,68.327c1.349,1.042,1.598,2.982,0.553,4.333l-14.518,19.499 c-1.045,1.349-2.981,1.597-4.333,0.555l-6.649-5.14c-1.35-1.044-1.599-2.983-0.554-4.334l14.518-19.499 c1.043-1.35,2.983-1.598,4.333-0.555L181.038,68.327z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgALogo);
export default __webpack_public_path__ + "static/media/a-logo.2cd777252c11097e74ab4124ad929676.svg";
export { ForwardRef as ReactComponent };